import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { __decorate } from "tslib";
import { DropdownMenu } from '../dropdown/menu';
import template from './content.vdt';
import { bind } from '../utils';
import { useArrow } from './useArrow';
import { tooltip as tooltipTheme } from './styles';
export var TooltipContent = /*#__PURE__*/function (_DropdownMenu) {
  _inheritsLoose(TooltipContent, _DropdownMenu);
  function TooltipContent() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _DropdownMenu.call.apply(_DropdownMenu, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.isEmptyChildren = true;
    _this.arrow = useArrow();
    return _this;
  }
  var _proto = TooltipContent.prototype;
  _proto.init = function init() {
    var _this2 = this;
    _DropdownMenu.prototype.init.call(this);
    this.on('$receive:children', function (vNodes) {
      _this2.isEmptyChildren = isEmptyChildren(vNodes);
    });
  };
  _proto.onEnter = function onEnter(elem) {
    // fix the width, https://github.com/ksc-fe/kpc/issues/873
    var maxWidth = parseInt(tooltipTheme.maxWidth);
    var width = elem.offsetWidth;
    if (width === maxWidth) {
      elem.style.width = width + "px";
    }
    this.dropdown.position();
  };
  _proto.onAfterLeave = function onAfterLeave(elem) {
    // remove the position after leave, https://github.com/ksc-fe/kpc/issues/873
    var style = elem.style;
    style.left = style.top = style.width = '';
  };
  _proto.onMouseEnter = function onMouseEnter(e) {
    var dropdown = this.dropdown;
    if (dropdown.get('hoverable')) {
      dropdown.show();
    }
    dropdown.trigger('mouseenter', e);
  };
  _proto.ok = function ok() {
    var dropdown = this.dropdown;
    dropdown.hide(true);
    dropdown.trigger('ok');
  };
  _proto.cancel = function cancel() {
    var dropdown = this.dropdown;
    dropdown.hide(true);
    dropdown.trigger('cancel');
  };
  return TooltipContent;
}(DropdownMenu);
TooltipContent.template = template;
__decorate([bind], TooltipContent.prototype, "onEnter", null);
__decorate([bind], TooltipContent.prototype, "onAfterLeave", null);
__decorate([bind], TooltipContent.prototype, "onMouseEnter", null);
__decorate([bind], TooltipContent.prototype, "ok", null);
__decorate([bind], TooltipContent.prototype, "cancel", null);
function isEmptyChildren(vNodes) {
  if (!vNodes) return true;
  if (Array.isArray(vNodes)) {
    return vNodes.every(function (vNode) {
      return isEmptyChildren(vNode);
    });
  }
  if (vNodes.type === 1) {
    return !vNodes.children;
  }
  return false;
}
;